// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__Av4r5","message":"styles_message__M5oNA"};